export default __webpack_public_path__ + "static/media/zodiac04.c79fb416.png";